import * as React from 'react';
import { SVGProps } from 'react';

const IconCollapseSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15 3v6h6v2h-8V3h2zM9 21v-6H3v-2h8v8H9z" />
  </svg>
);
export default IconCollapseSizeM;
